//
import Model from '@/models/Model'

//
export default class WhTransferWarehouseState extends Model {

    /**
     * 
     */
    resource() {
        return "wh_transfer_warehouse_state"
    }
}